import { render, staticRenderFns } from "./ListaDoble.vue?vue&type=template&id=06a47a68"
import script from "./ListaDoble.vue?vue&type=script&lang=js"
export * from "./ListaDoble.vue?vue&type=script&lang=js"
import style0 from "./ListaDoble.vue?vue&type=style&index=0&id=06a47a68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports